import {
  Section,
  SidebarNode,
  useSidebarTreeStore,
} from '../../../../store/storeSidebarTree';
import { getSiblingIds } from './selectors';
import type { DropData, DropPosition } from './types';

export interface NeighborRanks {
  prev?: string;
  next?: string;
}

const rankOfLast = (
  ids: string[],
  nodes: Record<string, SidebarNode>,
): string | undefined => {
  if (ids.length === 0) return undefined;
  return nodes[ids[ids.length - 1]]?.rank;
};

const targetIdFor = (
  over: DropData,
  position: DropPosition | null,
): string | null => {
  if (over.kind === 'item-drop') return over.itemId;
  if (
    over.kind === 'folder-drop' &&
    (position === 'above' || position === 'below')
  ) {
    return over.folderId;
  }
  return null;
};

export const computeNeighbors = (
  parentId: string | null,
  section: Section,
  spaceId: string | null,
  excludeId: string,
  over: DropData,
  position: DropPosition | null,
): NeighborRanks => {
  const state = useSidebarTreeStore.getState();
  const siblings = getSiblingIds(state, parentId, section, spaceId).filter(
    id => id !== excludeId,
  );

  const targetId = targetIdFor(over, position);
  if (!targetId) {
    return {
      prev: rankOfLast(siblings, state.nodes),
      next: undefined,
    };
  }

  const targetIdx = siblings.indexOf(targetId);
  if (targetIdx === -1) {
    return { prev: rankOfLast(siblings, state.nodes), next: undefined };
  }

  if (position === 'above') {
    return {
      prev:
        targetIdx > 0 ? state.nodes[siblings[targetIdx - 1]]?.rank : undefined,
      next: state.nodes[siblings[targetIdx]]?.rank,
    };
  }
  return {
    prev: state.nodes[siblings[targetIdx]]?.rank,
    next:
      targetIdx < siblings.length - 1
        ? state.nodes[siblings[targetIdx + 1]]?.rank
        : undefined,
  };
};
